import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

const DAYS = [["mon", "Monday"], ["tue", "Tuesday"], ["wed", "Wednesday"], ["thu", "Thursday"], ["fri", "Friday"], ["sat", "Saturday"], ["sun", "Sunday"]];
const HOURS = Array.from({ length: 13 }, (_, i) => `${String(i + 8).padStart(2, "0")}:00`);

export const AvailabilityEditor = ({ profile }) => {
  const [slots, setSlots] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => { setSlots(profile?.availability || {}); }, [profile]);

  const toggle = (day, hour) => {
    const current = slots[day] || [];
    setSlots({ ...slots, [day]: current.includes(hour) ? current.filter((h) => h !== hour) : [...current, hour].sort() });
  };

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/practitioners/me/availability", { slots });
      toast.success("Availability saved");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  if (!profile) return <p className="text-sm text-muted-foreground">Create your profile first, then set your weekly availability.</p>;

  return (
    <div data-testid="availability-editor">
      <p className="text-sm text-muted-foreground mb-6">Tap the hours you're open each week. Seekers can book any highlighted time up to 30 days out.</p>
      <div className="space-y-4">
        {DAYS.map(([key, label]) => (
          <div key={key}>
            <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-2">{label}</p>
            <div className="flex flex-wrap gap-1.5" data-testid={`availability-day-${key}`}>
              {HOURS.map((h) => {
                const on = (slots[key] || []).includes(h);
                return (
                  <button key={h} type="button" data-testid={`availability-${key}-${h.replace(":", "")}`} onClick={() => toggle(key, h)}
                    className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${on ? "border-primary text-primary bg-primary/10" : "border-border text-muted-foreground hover:text-foreground"}`}>
                    {h}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <Button data-testid="availability-save-btn" onClick={save} disabled={busy} className="rounded-full px-8 mt-8">
        {busy ? "Saving…" : "Save availability"}
      </Button>
    </div>
  );
};
